module.exports = __webpack_public_path__ + "static/media/external_env_1_media_8.c8d98045.webp";